import type { Address } from "viem";
import { hardwareBurnerArtifact, hardwareReceiverArtifact } from "./generated/contractArtifacts";

export const BURN_TOKEN: Address = "0x82e30A63bccDe3724877878A30C4977b52348198";
export const HARDWARE_COLLECTION: Address = "0x0c3dd3c403b6B5c0CCe2a97F15820a4Eae347FE7";
export const HARDWARE_METADATA_BASE_URI = "https://hardware.jack.art/metadata";
export const LEGACY_BURNER: Address = "0xDB38e10f38722Ca91006c7eEcc4DA7a731027344";
export const LEGACY_MINTER: Address = "0x1bf979282181f2b7a640d17aB5D2e25125F2de5e";
export const LEGACY_VECTOR = "0x20ef40c2f33c854d4dfbbe9c2b3bda9549d00808223a1dff8a905a0b715ed645" as const;

export const erc1155Abi = [
  {
    type: "function",
    name: "getTokenInfo",
    stateMutability: "view",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{
      name: "",
      type: "tuple",
      components: [
        { name: "uri", type: "string" },
        { name: "maxSupply", type: "uint256" },
        { name: "totalMinted", type: "uint256" },
      ],
    }],
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      { name: "account", type: "address" },
      { name: "id", type: "uint256" },
    ],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "isApprovedForAll",
    stateMutability: "view",
    inputs: [
      { name: "account", type: "address" },
      { name: "operator", type: "address" },
    ],
    outputs: [{ name: "", type: "bool" }],
  },
  {
    type: "function",
    name: "setApprovalForAll",
    stateMutability: "nonpayable",
    inputs: [
      { name: "operator", type: "address" },
      { name: "approved", type: "bool" },
    ],
    outputs: [],
  },
] as const;

export const burnerAbi = hardwareBurnerArtifact.abi;
export const receiverAbi = hardwareReceiverArtifact.abi;

export const legacyBurnerAbi = [
  {
    type: "function",
    name: "numCrosschainRedeemedTokens",
    stateMutability: "view",
    inputs: [{ name: "mechanicVectorId", type: "bytes32" }],
    outputs: [{ name: "", type: "uint256" }],
  },
] as const;

export const hardwareCollectionAbi = [
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "supply",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
  },
  {
    type: "function",
    name: "baseURI",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "string" }],
  },
  {
    type: "function",
    name: "tokenURI",
    stateMutability: "view",
    inputs: [{ name: "tokenId", type: "uint256" }],
    outputs: [{ name: "", type: "string" }],
  },
  {
    type: "function",
    name: "owner",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
  },
  {
    type: "function",
    name: "registerMinter",
    stateMutability: "nonpayable",
    inputs: [{ name: "minter", type: "address" }],
    outputs: [],
  },
  {
    type: "function",
    name: "unregisterMinter",
    stateMutability: "nonpayable",
    inputs: [{ name: "minter", type: "address" }],
    outputs: [],
  },
  {
    type: "function",
    name: "minters",
    stateMutability: "view",
    inputs: [
    ],
    outputs: [{ name: "", type: "address[]" }],
  },
  {
    type: "function",
    name: "setBaseURI",
    stateMutability: "nonpayable",
    inputs: [{ name: "newBaseURI", type: "string" }],
    outputs: [],
  },
] as const;
